import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useAuth } from '@/controllers/useAuth';
import { LoginView } from './views/LoginView';
import { IntakeView } from './views/IntakeView';
import { ListView } from './views/ListView';
import { DetailView } from './views/DetailView';
import { IssuesLayout } from './views/layout/IssuesLayout';

function NotFound() {
  return (
    <div className="py-10 text-center text-[13px] text-[var(--text-muted)]">
      404 — Route nicht gefunden.
    </div>
  );
}

export default function App() {
  const { user, loading, error, startGoogleLogin, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center gap-3 text-[var(--text-muted)]">
        <span
          className="w-3 h-3 rounded-full border-2 border-[var(--text-muted)] border-t-transparent"
          style={{ animation: 'spin 0.7s linear infinite' }}
        />
        <span className="text-[11px] uppercase tracking-[0.18em] font-mono">SESSION CHECK</span>
      </div>
    );
  }

  if (!user) {
    return (
      <ErrorBoundary>
        <BrowserRouter>
          <LoginView onLogin={startGoogleLogin} error={error} />
        </BrowserRouter>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<IssuesLayout user={user} onLogout={logout} />}>
            <Route path="/" element={<IntakeView />} />
            <Route path="/list" element={<ListView />} />
            <Route path="/i/:id" element={<DetailView />} />
            <Route path="/auth/google/callback" element={<IntakeView />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
